
import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import ProtectedRoute from './ProtectedRoute';
import { UserRole } from '../types';

// Layouts
import AuthLayout from '../layouts/AuthLayout';
import UserLayout from '../layouts/UserLayout';
import AdminLayout from '../layouts/AdminLayout';

// Auth Pages
import Login from '../pages/auth/Login';
import Register from '../pages/auth/Register';
import ForgotPassword from '../pages/auth/ForgotPassword';
import ResetPassword from '../pages/auth/ResetPassword';

// User Pages
import UserDashboard from '../pages/user/Dashboard';
import UserTrades from '../pages/user/Trades';
import UserWithdrawals from '../pages/user/Withdrawals';
import UserProfile from '../pages/user/Profile';
import UserReports from '../pages/user/Reports';
import UserSettings from '../pages/user/Settings';
import ChangePassword from '../pages/user/ChangePassword';

// Admin Pages
import AdminDashboard from '../pages/admin/Dashboard';
import AdminUsers from '../pages/admin/Users';
import AdminKyc from '../pages/admin/Kyc';
import AdminWithdrawals from '../pages/admin/Withdrawals';
import AdminTrading from '../pages/admin/Trading';
import AdminReports from '../pages/admin/Reports';
import AdminSettings from '../pages/admin/Settings';

const AppRoutes: React.FC = () => {
  return (
    <Routes>
      {/* Public/Auth Routes */}
      <Route element={<AuthLayout />}>
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/reset-password" element={<ResetPassword />} />
      </Route>

      {/* User Routes */}
      <Route
        path="/user"
        element={
          <ProtectedRoute allowedRoles={[UserRole.USER]}>
            <UserLayout />
          </ProtectedRoute>
        }
      >
        <Route index element={<Navigate to="/user/dashboard" replace />} />
        <Route path="dashboard" element={<UserDashboard />} />
        <Route path="trades" element={<UserTrades />} />
        <Route path="withdrawals" element={<UserWithdrawals />} />
        <Route path="profile" element={<UserProfile />} />
        <Route path="reports" element={<UserReports />} />
        <Route path="settings" element={<UserSettings />} />
        <Route path="change-password" element={<ChangePassword />} />
      </Route>

      {/* Admin Routes */}
      <Route
        path="/admin"
        element={
          <ProtectedRoute allowedRoles={[UserRole.ADMIN]}>
            <AdminLayout />
          </ProtectedRoute>
        }
      >
        <Route index element={<Navigate to="/admin/dashboard" replace />} />
        <Route path="dashboard" element={<AdminDashboard />} />
        <Route path="users" element={<AdminUsers />} />
        <Route path="kyc" element={<AdminKyc />} />
        <Route path="withdrawals" element={<AdminWithdrawals />} />
        <Route path="trading" element={<AdminTrading />} />
        <Route path="reports" element={<AdminReports />} />
        <Route path="settings" element={<AdminSettings />} />
        <Route path="change-password" element={<ChangePassword />} />
      </Route>

      {/* Root redirect */}
      <Route path="/" element={<Navigate to="/login" replace />} />
      <Route path="*" element={<Navigate to="/login" replace />} />
    </Routes>
  );
};

export default AppRoutes;
